module.exports = __webpack_public_path__ + "img/sv59.c1734427.svg";